import React from 'react';
import { Clock, ArrowRight, Wallet, Footprints } from 'lucide-react';
import { toBengaliNumeral } from '../utils/bengaliHelpers';
import { motion } from 'framer-motion';
interface RouteCardProps {
  type: 'recommended' | 'cheapest' | 'fastest';
  duration: string;
  priceRange: string;
  modes: string[];
  onClick: () => void;
}
export function RouteCard({
  type,
  duration,
  priceRange,
  modes,
  onClick
}: RouteCardProps) {
  const getBadge = () => {
    switch (type) {
      case 'recommended':
        return {
          text: 'AI রিকমেন্ডেড',
          color: 'bg-[#006a4e]/10 text-[#006a4e]'
        };
      case 'cheapest':
        return {
          text: 'সবচেয়ে সাশ্রয়ী',
          color: 'bg-green-100 text-green-700'
        };
      case 'fastest':
        return {
          text: 'সবচেয়ে দ্রুত',
          color: 'bg-orange-100 text-orange-700'
        };
      default:
        return null;
    }
  };
  const badge = getBadge();
  return <motion.div whileTap={{
    scale: 0.98
  }} onClick={onClick} className="bg-white p-5 rounded-2xl shadow-sm border border-gray-200 mb-4 relative overflow-hidden cursor-pointer" data-id="element-61">
      {badge && <div className={`absolute top-0 right-0 px-3 py-1 rounded-bl-xl text-xs font-bold font-bengali ${badge.color}`} data-id="element-62">
          {badge.text}
        </div>}

      <div className="flex justify-between items-start mb-4 mt-2" data-id="element-63">
        <div className="flex space-x-2" data-id="element-64">
          {modes.map((mode, idx) => <div key={idx} className="bg-gray-100 p-2 rounded-lg text-gray-600" data-id="element-65">
              {/* Simple text representation for now, could be icons */}
              <span className="text-xs font-bengali font-medium" data-id="element-66">{mode}</span>
            </div>)}
        </div>
      </div>

      <div className="flex justify-between items-end" data-id="element-67">
        <div className="space-y-1" data-id="element-68">
          <div className="flex items-center text-gray-500 text-sm font-bengali" data-id="element-69">
            <Clock size={16} className="mr-1" data-id="element-70" />
            <span data-id="element-71">মোট সময়: {duration}</span>
          </div>
          <div className="flex items-center text-gray-900 font-bold text-xl font-bengali" data-id="element-72">
            <Wallet size={20} className="mr-2 text-[#006a4e]" data-id="element-73" />
            <span data-id="element-74">{priceRange}</span>
          </div>
        </div>

        <button className="text-[#006a4e] font-bold font-bengali flex items-center text-sm" data-id="element-75">
          বিস্তারিত
          <ArrowRight size={16} className="ml-1" data-id="element-76" />
        </button>
      </div>
    </motion.div>;
}